// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"4681c660","977":"3ecaef67"}[chunkId] + ".chunk.js";
};